import { PublicClientApplication } from "@azure/msal-browser";
import { msalConfig } from "./msalConfig";

export const msalInstance = new PublicClientApplication(msalConfig);

// Fonction de callback pour gérer la réponse de redirection
msalInstance.handleRedirectPromise().catch((error) => {
    console.error("Msal Redirect Error:", error);
});

// Sélectionner le compte actif si disponible
const accounts = msalInstance.getAllAccounts();
if (accounts.length > 0) {
    msalInstance.setActiveAccount(accounts[0]);
}

export default msalInstance;